import { render } from "./BankRecTabs.vue?vue&type=template&id=334a4fb7"
import script from "./BankRecTabs.vue?vue&type=script&lang=js"
export * from "./BankRecTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__